/* FAQ pages: chat and photo buttons, consent-gated GA4 clicks, question search, deep links that open a question. The page works without it. */
(() => {
  'use strict';
  if (window.wnfswFaqInit) return;
  window.wnfswFaqInit = true;
  const MID = 'G-0JE425EEKS';
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const track = (name, params = {}) => {
    if (!allowed() || typeof window.gtag !== 'function') return;
    window.gtag('event', name, { send_to: MID, page_location: 'https://whatsnewfurniture.com' + location.pathname, ...params });
  };
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const wire = (root) => {
    const ev = root.dataset.wnfswEvent;
    // Capture phase so this runs before Motion's link handler starts a page transition.
    document.addEventListener('click', (e) => {
      const cta = e.target.closest('[data-wnfsw-cta]');
      if (cta && root.contains(cta)) track(ev, { cta_placement: cta.dataset.wnfswCta, transport_type: 'beacon' });
      const c = e.target.closest('[data-wnfsw-chat]');
      if (c && root.contains(c) && typeof window.WNFChatOpen === 'function') {
        // Motion binds a page-transition click handler to every <a> (it navigates by hand), so stop the event here.
        e.preventDefault();
        e.stopPropagation();
        window.WNFChatOpen(c.dataset.wnfswChat === 'photo' ? { intent: 'photo' } : undefined);
      }
    }, true);
  };

  const norm = (s) => s.toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9$ ]+/g, ' ');
  // Light stemming so "returns", "deliveries" or "shipping" still find "return", "delivery", "ship".
  const forms = (w) => [w, w.replace(/ies$/, 'y'), w.replace(/(es|s)$/, ''), w.replace(/(ing|ed)$/, ''), w.replace(/(ping|ped)$/, '')].filter((x) => x.length >= 3 || x === w);
  const SYN = { couch: ['sofa'], couches: ['sofa'], loveseat: ['sofa'], finance: ['affirm'], financing: ['affirm'], layaway: ['pay over time'], open: ['hours'], appointment: ['walk in'] };
  const hit = (text, w) => forms(w).concat(SYN[w] || []).some((f) => text.includes(f));
  const search = (root) => {
    const form = root.querySelector('[data-wnfsw-search]');
    if (!form) return;
    const input = form.querySelector('input');
    const groups = [...root.querySelectorAll('[data-wnfsw-group]')];
    const empty = root.querySelector('[data-wnfsw-empty]');
    const count = root.querySelector('[data-wnfsw-count]');
    let timer;
    const first = () => [...root.querySelectorAll('[data-wnfsw-group] details')].find((d) => d.getClientRects().length);
    form.hidden = false;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const d = first();
      if (d) { d.open = true; d.scrollIntoView({ block: 'start', behavior: 'smooth' }); d.querySelector('summary').focus({ preventScroll: true }); }
      else if (empty && !empty.hidden) empty.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
    input.addEventListener('input', () => {
      const q = norm(input.value).trim().split(/\s+/).filter(Boolean);
      let shown = 0;
      root.classList.toggle('is-searching', q.length > 0);
      groups.forEach((g) => {
        let n = 0;
        const head = norm((g.querySelector('h2, h3') || {}).textContent || '');
        g.querySelectorAll('details').forEach((d) => {
          const text = norm(d.textContent) + ' ' + head;
          const ok = !q.length || q.every((w) => hit(text, w));
          d.hidden = !ok;
          if (ok) n++;
          d.open = q.length > 0 && ok && n <= 2;
        });
        g.hidden = q.length > 0 && !n;
        shown += n;
      });
      if (empty) empty.hidden = shown > 0 || !q.length;
      if (count) count.textContent = q.length ? (shown === 1 ? '1 answer' : shown + ' answers') : '';
      clearTimeout(timer);
      if (q.length) timer = setTimeout(() => track(root.dataset.wnfswEvent.replace('_cta_click', '_search'), { search_term: input.value.slice(0, 60), results: shown }), 1200);
    });
  };
  const openHash = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    const el = id && document.getElementById(id);
    if (el && el.tagName === 'DETAILS') { el.open = true; el.scrollIntoView({ block: 'start' }); }
  };
  const init = () => {
    const root = document.querySelector('[data-wnfsw-service-page][data-wnfsw-event]');
    if (!root) return;
    wire(root);
    search(root);
    openHash();
    window.addEventListener('hashchange', openHash);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
